module.exports = {
	"permanent": "Permanent",
	"buttons": {
		"cancel": "Anuluj",
		"close": "Zamknij",
		"copy": "Kopiuj",
		"copyFile": "Kopiuj plik",
		"copyToClipboard": "kopiuj do schowka",
		"create": "Utwórz",
		"delete": "Usuń",
		"download": "Pobierz",
		"info": "Informacja",
		"more": "Więce",
		"move": "Przenieś",
		"moveFile": "Przenieś plik",
		"new": "Nowy",
		"next": "Następny",
		"ok": "OK",
		"replace": "Zamień",
		"previous": "Poprzedni",
		"rename": "Zmień Nazwę",
		"reportIssue": "Zgłoś Problem",
		"save": "Zapisz",
		"search": "Szukaj",
		"select": "Wybierz",
		"share": "Udostępnij",
		"publish": "Opublikuj",
		"selectMultiple": "Zaznacz wiele",
		"schedule": "Grafik",
		"switchView": "Zmień widok",
		"toggleSidebar": "Toggle sidebar",
		"update": "Aktualizuj",
		"upload": "Upload",
		"permalink": "Get Permanent Link"
	},
	"success": {
		"linkCopied": "Link Skopiowany!"
	},
	"errors": {
		"forbidden": "Nie jesteś tu mile widziany.",
		"internal": "Pojawił się poważny problem.",
		"notFound": "Ten adres nie jest poprawny."
	},
	"files": {
		"folders": "Foldery",
		"files": "Pliki",
		"body": "Body",
		"clear": "Wyczyść",
		"closePreview": "Zamknij poprzednie",
		"home": "Home",
		"lastModified": "Ostatnio modyfikowane",
		"loading": "Ładowanie...",
		"lonely": "Smutno gdy tak pusto...",
		"metadata": "Metadata",
		"multipleSelectionEnabled": "Multiple selection enabled",
		"name": "Nazwa",
		"size": "Rozmiar",
		"sortByName": "Sortuj po nazwie",
		"sortBySize": "Sortuj po rozmiarze",
		"sortByLastModified": "Sortuj po dacie modyfikacji"
	},
	"help": {
		"click": "wybierz plik lub foler",
		"ctrl": {
			"click": "wybierz wiele plików lub folderów",
			"f": "otwórz wyszukiwarkę",
			"s": "pobierz aktywny plik lub folder"
		},
		"del": "usuń zaznaczone",
		"doubleClick": "otwórz plik lub folder",
		"esc": "wyczyść zaznaczenie i/lub zamknij okno z powiadomieniem",
		"f1": "ta informacja",
		"f2": "zmień nazwę pliku",
		"help": "Pomoc"
	},
	"login": {
		"password": "Hasło",
		"submit": "Login",
		"username": "Nazwa użytkownika",
		"wrongCredentials": "Błędne dane logowania"
	},
	"prompts": {
		"copy": "Kopiuj",
		"copyMessage": "Wybierz lokalizację do której mają być skopiowane wybrane pliki",
		"currentlyNavigating": "Currently navigating on:",
		"deleteMessageMultiple": "Czy jesteś pewien że chcesz usunąć {count} plik(ów)?",
		"deleteMessageSingle": "Czy jesteś pewien, że chcesz usunąć ten plik/folder?",
		"deleteTitle": "Usuń pliki",
		"displayName": "Wyświetlana Nazwa:",
		"download": "Pobierz pliki",
		"downloadMessage": "Wybierz format, jaki chesz pobrać.",
		"error": "Pojawił się jakiś błąd",
		"fileInfo": "Informacje o pliku",
		"filesSelected": "{count} plików zostało zaznaczonych.",
		"lastModified": "Osatnio Zmodyfikowane",
		"move": "Przenieś",
		"moveMessage": "Wybierz nową lokalizację dla swoich plik(ów)/folder(ów):",
		"newDir": "Nowy folder",
		"newDirMessage": "Podaj nazwę tworzonego folderu.",
		"newFile": "Nowy plik",
		"newFileMessage": "Podaj nazwętworzonego pliku.",
		"numberDirs": "Ilość katalogów",
		"numberFiles": "Ilość plików",
		"replace": "Zamień",
		"replaceMessage": "Jednen z plików który próbujesz wrzucić próbje nadpisać plik o tej samej nazwie. Czy chcesz nadpisać poprzedni plik?\n",
		"rename": "Zmień nazwę",
		"renameMessage": "Podaj nową nazwę dla",
		"show": "Pokaż",
		"size": "Rozmiar",
		"schedule": "Grafi",
		"scheduleMessage": "Wybierz datę i czas dla publikacji tego wpisu.",
		"newArchetype": "Utwórz nowy wpis na bazie wybranego wzorca. Twój plik będzie utworzony w wybranym folderze."
	},
	"settings": {
		"admin": "Admin",
		"administrator": "Administrator",
		"allowCommands": "Wykonaj polecenie",
		"allowEdit": "Edycja, zmiana nazwy i usuniecie plików lub folderów",
		"allowNew": "Tworzenie nowych plików lub folderów",
		"allowPublish": "Tworzenie nowych wpisów i stron",
		"avoidChanges": "(pozostaw puste aby nie zosatało zmienione)",
		"changePassword": "Zmień Hasło",
		"commands": "Polecenia",
		"commandsHelp": "Here you can set commands that are executed in the named events. You write one command per line. If the event is related to files, such as before and after saving, the environment variable \"FILE\" will be available with the path of the file.\n",
		"commandsUpdated": "Polecenie zaktualizowane!",
		"customStylesheet": "Własny Stylesheet",
		"examples": "Przykłady",
		"globalSettings": "Ustawienia Globalne",
		"language": "Język",
		"lockPassword": "Zablokuj użytkownikowi możliwość zmiany hasła",
		"newPassword": "Twoje nowe hasło",
		"newPasswordConfirm": "Potwierdź swoje hasło",
		"newUser": "Nowy Użytkownik",
		"password": "Hasło",
		"passwordUpdated": "Hasło zostało zapisane!",
		"permissions": "Uprawnienia",
		"permissionsHelp": "You can set the user to be an administrator or choose the permissions individually. If you select \"Administrator\", all of the other options will be automatically checked. The management of users remains a privilege of an administrator.\n",
		"profileSettings": "Twój profil",
		"ruleExample1": "prevents the access to any dot file (such as .git, .gitignore) in every folder.\n",
		"ruleExample2": "blocks the access to the file named Caddyfile on the root of the scope.",
		"rules": "Uprawnienia",
		"rulesHelp1": "Here you can define a set of allow and disallow rules for this specific user. The blocked files won't show up in the listings and they wont be accessible to the user. We support regex and paths relative to the users scope.\n",
		"rulesHelp2": "Each rule goes in one different line and must start with the keyword {0} or {1}. Then you should write {2} if you are using a regular expression and then the expression or the path.\n",
		"scope": "Scope",
		"settingsUpdated": "Uprawnienia Zapisane!",
		"user": "Użytkownik",
		"userCommands": "Polecenia",
		"userCommandsHelp": "A space separated list with the available commands for this user. Example:\n",
		"userCreated": "Użytkownik zapisany!",
		"userDeleted": "Użytkownik usunięty!",
		"userManagement": "Zarządzanie użytkownikami",
		"username": "Nazwa użytkownika",
		"users": "Użytkownicy",
		"userUpdated": "Użytkownik zapisany!"
	},
	"sidebar": {
		"help": "Pomoc",
		"logout": "Wyloguj",
		"myFiles": "Moje pliki",
		"newFile": "Nowy plik",
		"newFolder": "Nowy folder",
		"settings": "Ustawienia",
		"siteSettings": "Ustawienia Strony",
		"hugoNew": "Hugo New",
		"preview": "Podgląd"
	},
	"search": {
		"images": "Zdjęcia",
		"music": "Muzyka",
		"notSupportedCommand": "Polecenie niedozwolone.",
		"pdf": "PDF",
		"pressToExecute": "Naciśniej Enter aby wykonać.",
		"pressToSearch": "Naciśnij Enter aby wyszukać.",
		"search": "Szukaj...",
		"searchOrCommand": "Szukaj lub wykonaj polecenie...",
		"searchOrSupportedCommand": "Szukaj lub wpisz '$' i wybierz jedno z dostęnych poleceń:",
		"typeCommand": "Wpisz i naciśnij Enter aby wykonać.",
		"typeSearch": "Wpisz i naciśni Enter aby wyszukać.",
		"types": "Typy",
		"video": "Video",
		"writeToSearch": "Wpisz tu aby wyszukać"
	},
	"languages": {
		"en": "English",
		"it": "Italiano",
		"fr": "Français",
		"pt": "Português",
		"ptBR": "Português (Brasil)",
		"ja": "日本語",
		"zhCN": "中文 (简体)",
		"zhTW": "中文 (繁體)",
		"es": "Español",
		"de": "Deutsch",
		"ru": "Русский",
		"pl": "Polski"
	},
	"time": {
		"unit": "Jednostka czasu",
		"seconds": "Sekundy",
		"minutes": "Minuty",
		"hours": "Godziny",
		"days": "Dni"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/pl.yaml
// module id = 297
// module chunks = 0